module.exports = __webpack_public_path__ + "img/teacherNo2.d1ac8675.png";